import { Button } from '@/components/ui/button';
import { Minus } from 'lucide-react';
import PlusIcon from '../icons/PlusIcon';

interface QuantityControlProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
  min?: number;
  max?: number;
  size?: 'sm' | 'md' | 'lg';
}

export function QuantityControl({
  quantity,
  onIncrement,
  onDecrement,
  min = 1,
  max = 99,
  size = 'md',
}: QuantityControlProps) {
  const sizeClasses = {
    sm: 'h-8 w-10',
    md: 'h-[48px] w-[52px] sm:h-[51px] sm:w-[57px]',
    lg: 'h-12 w-14',
  };

  const iconSize = {
    sm: 14,
    md: 16,
    lg: 18,
  };

  const textSize = {
    sm: 'text-sm',
    md: 'text-[1.1rem] sm:text-[1.25rem]',
    lg: 'text-lg',
  };

  return (
    <div className="flex items-center gap-0 rounded-[10px] border border-black/20 w-fit mx-auto sm:mx-0">
      <Button
        onClick={onDecrement}
        disabled={quantity <= min}
        variant="ghost"
        className={`${sizeClasses[size]} rounded-l-[10px] rounded-r-none hover:bg-gray-100 disabled:opacity-30 p-0 flex items-center justify-center`}
      >
        <Minus size={iconSize[size]} className={size === 'md' ? 'sm:w-[17px] sm:h-[17px]' : ''} color="rgba(0, 0, 0, 0.50)" strokeWidth={2.08} />
      </Button>
      
      <div className={`${sizeClasses[size]} flex items-center justify-center border-x border-black/20`}>
        <span className={`font-lexend ${textSize[size]} font-normal tracking-[-0.20px] capitalize text-black`}>
          {quantity}
        </span>
      </div>
      
      <Button
        onClick={onIncrement}
        disabled={quantity >= max}
        variant="ghost"
        className={`${sizeClasses[size]} rounded-r-[10px] rounded-l-none hover:bg-gray-100 disabled:opacity-30 p-0 flex items-center justify-center`}
      >
        <PlusIcon width={iconSize[size]} height={iconSize[size]} className={size === 'md' ? 'sm:w-[17px] sm:h-[17px]' : ''} color="rgba(0, 0, 0, 0.50)" />
      </Button>
    </div>
  );
}